'use strict';

/**
 * Collection for the matching result
 *
 * @category   Collection
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var MatchModel = require('../models/match');

var MatchesCollection = ColidoCollection.extend({
    model: MatchModel,

    sortDefault: 'position.asc',

    /**
     * Returns the count of selected columns
     * @returns {number} The number of selected columns
     */
    selectedColumns: function() {
        return this.filter(function(model) {
            return model.hasColumnSelected();
        }).length;
    },

    /**
     * Returns the count of dismissed columns
     * @returns {number} The number of dismissed columns
     */
    dismissedColumns: function() {
        return this.filter(function(model) {
            return model.get('dismissed');
        }).length;
    },
});

module.exports = MatchesCollection;